import { gql } from '@apollo/client'

import { mailingAddressFragment, orderWithProductsFragment } from './common'

export const customerFragment = gql`
  ${orderWithProductsFragment}
  ${mailingAddressFragment}

  fragment CustomerFragment on Customer {
    id
    defaultAddress {
      id
    }
    addresses(first: 25) {
      edges {
        node {
          ...MailingAddressFragment
        }
      }
    }
    orders(first: 100, reverse: true) {
      edges {
        node {
          ...OrderWithProductsFragment
        }
      }
    }
  }
`

export const customerUserErrorFragment = gql`
  fragment CustomerUserErrorFragment on CustomerUserError {
    code
    field
    message
  }
`
